export default __webpack_public_path__ + "static/media/image.011463fe.png";